import { memo } from 'react'

interface PlatformIconProps {
  platform: string
  size?: number
  className?: string
}

export default memo(function PlatformIcon({ platform, size = 16, className = '' }: PlatformIconProps) {
  if (platform === 'bluesky') {
    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 568 501"
        fill="currentColor"
        className={className}
        aria-label="Bluesky"
      >
        <path d="M123.121 33.664C188.241 82.553 258.281 181.68 284 234.873c25.719-53.192 95.759-152.32 160.879-201.21C491.866-1.611 568-28.906 568 57.947c0 17.346-9.945 145.713-15.778 166.555-20.275 72.453-94.155 90.933-159.875 79.748C507.222 323.8 536.444 388.56 473.333 453.32c-119.86 122.992-172.272-30.859-185.702-70.281-2.462-7.227-3.614-10.608-3.631-7.733-.017-2.875-1.169.506-3.631 7.733-13.43 39.422-65.842 193.273-185.702 70.281-63.111-64.76-33.89-129.52 80.986-149.071-65.72 11.185-139.6-7.295-159.875-79.748C10.045 203.659.1 75.291.1 57.946.1-28.906 76.234-1.612 123.121 33.664Z" />
      </svg>
    )
  }

  if (platform === 'mastodon') {
    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 74 79"
        fill="currentColor"
        className={className}
        aria-label="Mastodon"
      >
        <path d="M73.147 21.93c0-14.2-9.306-18.367-9.306-18.367C59.15 1.326 50.54.08 41.556 0h-.224c-8.98.08-17.583 1.326-22.282 3.563 0 0-9.306 4.168-9.306 18.368 0 3.255-.063 7.148.04 11.302.322 13.97 2.427 27.738 14.639 31.166 5.634 1.582 10.47 1.913 14.363 1.686 7.067-.41 11.032-2.643 11.032-2.643l-.233-5.126s-5.05 1.592-10.722 1.397c-5.625-.194-11.565-.608-12.473-7.538a14.173 14.173 0 0 1-.126-1.96s5.517 1.348 12.507 1.668c4.27.196 8.27-.25 12.333-.737 7.787-.934 14.567-5.756 15.413-10.161 1.331-6.935 1.222-16.925 1.222-16.925ZM61.09 39.357H52.55V22.635c0-3.52-1.481-5.31-4.443-5.31-3.275 0-4.914 2.12-4.914 6.315v9.169H34.72v-9.17c0-4.194-1.64-6.314-4.915-6.314-2.962 0-4.443 1.79-4.443 5.31v16.722h-8.54v-17.22c0-3.52.895-6.316 2.691-8.39 1.852-2.074 4.28-3.137 7.293-3.137 3.487 0 6.127 1.34 7.882 4.02l1.698 2.848 1.699-2.849c1.755-2.679 4.395-4.019 7.882-4.019 3.012 0 5.44 1.063 7.293 3.137 1.796 2.074 2.69 4.87 2.69 8.39v17.22Z" />
      </svg>
    )
  }

  if (platform === 'x') {
    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        className={className}
        aria-label="X"
      >
        <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
      </svg>
    )
  }

  if (platform === 'facebook') {
    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        className={className}
        aria-label="Facebook"
      >
        <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
      </svg>
    )
  }

  if (platform === 'linkedin') {
    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        className={className}
        aria-label="LinkedIn"
      >
        <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
      </svg>
    )
  }

  if (platform === 'hackernews') {
    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        className={className}
        aria-label="Hacker News"
      >
        <path d="M0 0v24h24V0H0zm12.8 13.7v5.1h-1.6v-5.1L7 5.2h1.8l3.2 5.8 3.1-5.8H17l-4.2 8.5z" />
      </svg>
    )
  }

  if (platform === 'reddit') {
    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        className={className}
        aria-label="Reddit"
      >
        <path d="M12 0C5.373 0 0 5.373 0 12c0 3.314 1.343 6.314 3.515 8.485l-2.286 2.286C.775 23.225 1.097 24 1.738 24H12c6.627 0 12-5.373 12-12S18.627 0 12 0zm5.99 13.915c.033.227.05.46.05.697 0 3.09-3.495 5.598-7.816 5.598-4.32 0-7.816-2.508-7.816-5.598 0-.236.017-.468.05-.695A2.25 2.25 0 011 12.25a2.25 2.25 0 013.89-1.539c1.55-1.015 3.6-1.655 5.882-1.708l1.197-5.385a.396.396 0 01.478-.31l3.83.826a1.5 1.5 0 112.865.585l-3.586-.773-1.053 4.738c2.397.024 4.567.674 6.176 1.729A2.246 2.246 0 0123 12.25a2.25 2.25 0 01-1.01 1.665zM8.25 12.5a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm7.5 0a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm-7.498 5.748a.5.5 0 01-.003-.707c1.76-1.76 5.738-1.76 7.498 0a.5.5 0 01-.707.707c-1.37-1.37-4.824-1.38-6.081 0a.5.5 0 01-.707 0z" />
      </svg>
    )
  }

  return (
    <span
      className={`inline-flex items-center justify-center rounded-full bg-muted/20 text-muted font-medium ${className}`}
      style={{ width: size, height: size, fontSize: size * 0.6 }}
      aria-label={platform}
    >
      {platform.charAt(0).toUpperCase()}
    </span>
  )
})
